import {AnimationAction, AnimationMixer, Clock, Color, PerspectiveCamera, Scene, Vector3, WebGLRenderer} from 'three';
import {Audio as Three_Audio} from "three/src/audio/Audio";

export type amy3DHolderType = {
  bufferScene: Scene;
  bufferCamera: PerspectiveCamera & {
    lookAtPosition: Vector3;
  };
  renderer: WebGLRenderer;
  amyClearColor: Color;
  matrixClearColor: Color;

  mixer: AnimationMixer;
  clock: Clock;

  amySettings: {
    particlesHitArea: boolean;
    particlesRandom: number;
    particlesDepth: number;
    particlesXYMove: boolean;
    particlesBW: boolean;
    particlesSquare: boolean;
    particlesSize: number;
    particlesSmooth: number;
    particlesShift: number;
    matrix: number;
    planeRotate: number;
  };
  curAnimationModel: any;

  curAction: AnimationAction;
  modelAnimations: AnimationAction[];
  modelAnimationsNamed: { [id: string]: AnimationAction };

  morphTarget: (targetName:amyMorphtargets, value:number)=>void;
  sound: Three_Audio;
};

export enum amyMorphtargets {
  browDownLeft = 'browDownLeft',
  browDownRight = 'browDownRight',
  browInnerUp = 'browInnerUp',
  browOuterUpLeft = 'browOuterUpLeft',
  browOuterUpRight = 'browOuterUpRight',
  cheekPuff = 'cheekPuff',
  cheekSquintLeft = 'cheekSquintLeft',
  cheekSquintRight = 'cheekSquintRight',
  eyeBlinkLeft = 'eyeBlinkLeft',
  eyeBlinkRight = 'eyeBlinkRight',
  eyeLookDownLeft = 'eyeLookDownLeft',
  eyeLookDownRight = 'eyeLookDownRight',
  eyeLookInLeft = 'eyeLookInLeft',
  eyeLookInRight = 'eyeLookInRight',
  eyeLookOutLeft = 'eyeLookOutLeft',
  eyeLookOutRight = 'eyeLookOutRight',
  eyeLookUpLeft = 'eyeLookUpLeft',
  eyeLookUpRight = 'eyeLookUpRight',
  eyeSquintLeft = 'eyeSquintLeft',
  eyeSquintRight = 'eyeWideLeft',
  eyeWideLeft = 'eyeWideLeft',
  eyeWideRight = 'eyeWideRight',
  eyesClosed = 'eyesClosed',
  eyesLookDown = 'eyesLookDown',
  eyesLookUp = 'eyesLookUp',
  jawForward = 'jawForward',
  jawLeft = 'jawLeft',
  jawOpen = 'jawOpen',
  jawRight = 'jawRight',
  mouthClose = 'mouthClose',
  mouthDimpleLeft = 'mouthDimpleLeft',
  mouthDimpleRight = 'mouthDimpleRight',
  mouthFrownLeft = 'mouthFrownLeft',
  mouthFrownRight = 'mouthFrownRight',
  mouthFunnel = 'mouthFunnel',
  mouthLeft = 'mouthLeft',
  mouthLowerDownLeft = 'mouthLowerDownLeft',
  mouthLowerDownRight = '',
  mouthOpen = 'mouthOpen',
  mouthPressLeft = 'mouthPressLeft',
  mouthPressRight = 'mouthPressRight',
  mouthPucker = 'mouthPucker',
  mouthRight = 'mouthRight',
  mouthRollLower = 'mouthRollLower',
  mouthRollUpper = 'mouthRollUpper',
  mouthShrugLower = 'mouthShrugLower',
  mouthShrugUpper = 'mouthShrugUpper',
  mouthSmile = 'mouthSmile',
  mouthSmileLeft = 'mouthSmileLeft',
  mouthSmileRight = 'mouthSmileRight',
  mouthStretchLeft = 'mouthStretchLeft',
  mouthStretchRight = 'mouthStretchRight',
  mouthUpperUpLeft = 'mouthUpperUpLeft',
  mouthUpperUpRight = 'mouthUpperUpRight',
  noseSneerLeft = 'noseSneerLeft',
  noseSneerRight = 'noseSneerRight',
  tongueOut = 'tongueOut',
  viseme_CH = 'viseme_CH',
  viseme_DD = 'viseme_DD',
  viseme_E = 'viseme_E',
  viseme_FF = 'viseme_FF',
  viseme_I = 'viseme_I',
  viseme_O = 'viseme_O',
  viseme_PP = 'viseme_PP',
  viseme_RR = 'viseme_RR',
  viseme_SS = 'viseme_SS',
  viseme_TH = 'viseme_TH',
  viseme_U = 'viseme_U',
  viseme_aa = 'viseme_aa',
  viseme_kk = 'viseme_kk',
  viseme_nn = 'viseme_nn',
  viseme_sil = 'viseme_sil',
}

export const amyMorphTargetGroups = {
  eyeBlinkLeft: 'EyeLeft',
  eyeBlinkRight: 'eyeBlinkRight',
  eyeLookDownLeft: 'EyeLeft',
  eyeLookDownRight: 'eyeLookDownRight',
  eyeLookOutLeft: 'EyeLeft',
  eyeLookOutRight: 'eyeLookOutRight',
  eyeLookUpLeft: 'EyeLeft',
  eyeLookUpRight: 'eyeLookUpRight',
}
